import gsap, { Power1, Power2, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin)

export class MyChoice {
  constructor() {
    const isSP = window.matchMedia("(max-width: 743px)").matches;

    if (isSP) {
      this.initSP();
      return;
    }

    // --- PC処理（省略せずそのまま） ---
    const end = "+=3000";

    ScrollTrigger.create({
      trigger: ".p-index_choice",
      start: "top top",
      end: end,
      pin: true,
      pinSpacing: true,
      pinnedContainer: ".p-index_choice",
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".p-index_choice",
        start: "top top",
        end: end,
        scrub: 1,
      }
    });

    tl.from(".p-index_choice__copy__title", {
        opacity: 0,
        y: 40,
        stagger: 2.0,
        duration: 3,
        ease: Power2.easeOut,
      })
      .from(".p-index_choice__circle", {
        opacity: 0,
        duration: 4,
        ease: Power2.easeOut,
        transformOrigin: "center center",
      }, "-=1")
      .from(".p-index_choice__gallery", {
        opacity: 0,
        duration: 4,
        ease: Power2.easeOut,
        transformOrigin: "center center",
      }, "-=1")
      .from(".p-index_choice__gallery__bg", {
        scale: 0,
        opacity: 0,
        duration: 4,
        ease: Power2.easeOut,
        transformOrigin: "center center",
      }, "-=1")
      .from(".p-index_choice__gallery__main .boy", {
        opacity: 0,
        y: 60,
        duration: 4,
        stagger: 2.0,
        ease: Power2.easeOut,
      }, "<")
      .from(".p-index_choice__gallery__main .girl", {
        opacity: 0,
        y: 60,
        duration: 4,
        stagger: 2.0,
        ease: Power2.easeOut,
      }, "-=1")
      .fromTo(".p-index_choice__gallery__pic",
        { y: "150%" },
        { y: "-180%", duration: 40, stagger: 2.0, ease: Power1.easeOut },
        "<"
      )
      .from(".p-index_choice__copy__text p", {
        opacity: 0,
        y: 20,
        duration: 6,
        stagger: 3.0,
        ease: Power2.easeOut,
      }, "<")

    const picParallax = [
      { selector: ".pic01", to: "-5%", scrub: 0.5 },
      { selector: ".pic02", to: "30%", scrub: 3 },
      { selector: ".pic03", to: "20%", scrub: 1 },
      { selector: ".pic04", to: "-30%", scrub: 4 },
      { selector: ".pic05", to: "-20%", scrub: 2 },
    ];

    picParallax.forEach(({ selector, to, scrub }) => {
      gsap.to(`.p-index_choice__gallery__pic ${selector}`, {
        y: to,
        ease: "none",
        scrollTrigger: {
          trigger: ".p-index_choice",
          start: "top top",
          end: end,
          scrub: scrub,
        }
      });
    });
  }

  initSP() {
    // ① pic を下から上へ流す（セクションが見えている間ずっと動く）
    gsap.fromTo(".p-index_choice__gallery__pic",
      { y: "50%" },
      {
        y: "-100%",
        ease: Power1.easeOut,
        stagger: 0.3,
        scrollTrigger: {
          trigger: ".p-index_choice",
          start: "top bottom",   // セクションが画面下端に入ったら開始
          end: "bottom top",     // セクションが画面上端を抜けたら終了
          scrub: 2,
        }
      }
    );

    // ② テキスト類を順番にフェードイン（スクロールトリガー）
    const textTargets = [
      ".p-index_choice__copy__title",
      ".p-index_choice__circle",
      ".p-index_choice__gallery",
      ".p-index_choice__copy__text p",
    ];

    textTargets.forEach((selector) => {
      gsap.from(selector, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        stagger: 0.15,
        ease: Power2.easeOut,
        scrollTrigger: {
          trigger: selector,
          start: "top 85%",   // 要素が画面の85%ラインに入ったら発火
          toggleActions: "play none none none",
        }
      });
    });
  }
}